"use client"

import { useEffect } from 'react'
import Button from '@components/button/Button'
import Link from 'next/link'
import useT from '@hooks/useTranslation'
// import simpleDate from '@utils/date/simpleDate'

const MOTORAPORTER_URL = 'https://motoraporter.com/'

export default function Carq({ offer }) {
	const { type, vin } = offer // data, moreinfo,
	// const { registration_number } = data || {}

	// const {
	//     'dealer-data-pierwszej-rejestracji': dealer_first_registration_date,
	//     first_registration_date,
	// } = moreinfo || {}
	// const firstRegistrationDate = dealer_first_registration_date || first_registration_date

	useEffect(() => {
		const script = document.createElement('script')
		script.src =
			'//carq-widget-bucket.s3.eu-central-1.amazonaws.com/widget/partner-2cafa8c7-6d5e-4261-8f61-089f498298cd.js'
		script.async = true

		document.body.appendChild(script)

		return () => document.body.removeChild(script)
	}, [])

	const carVerticalUrl = `https://www.carvertical.com/pl/precheck?utm_source=aff&a=samochodypl&b=8094cbda&vin=${(
		vin || ''
	).trim()}&voucher=samochod`
	const showCarVertical = ['car_ad', 'truck_ad'].includes(type)
	const linkProps = {
		target: '_blank',
		rel: 'noopener noreferrer nofollow',
	}

	return <>
        {showCarVertical && (
            <>
                <h2>{useT('Historia pojazdu')}</h2>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
                    <Link href={carVerticalUrl} {...linkProps}>

                        <CarqButton t="Sprawdź historię" />

                    </Link>
                    <div
                        style={{
                            alignItems: 'center',
                            display: 'flex',
                            gap: 12,
                        }}
                    >
                        <span style={{ fontWeight: 'normal' }}>
                            {useT('Partner')}:{' '}
                        </span>
                        <img
                            src="/assets/icons/car-vertical.svg"
                            style={{ width: 122, height: 25 }}
                        ></img>
                    </div>
                </div>
            </>
        )}

        <br />
        <hr />
        {/* <h2>Zleć badanie przed zakupem</h2>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
            <Link href={MOTORAPORTER_URL} {...linkProps}>

                <CarqButton t="Zleć badanie" />

            </Link>
            <div
                style={{ alignItems: 'center', display: 'flex', gap: 12 }}
            >
                <span style={{ fontWeight: 'normal' }}>
                    {useT('Partner')}:{' '}
                </span>
                <img
                    src="/assets/icons/motoraporter.png"
                    style={{ width: 140 }}
                ></img>
            </div>
        </div>
        <br />
        <hr /> */}
    </>;
}

function CarqButton(props) {
	return (
		<Button {...props} teal>
			{useT(props.t || 'Sprawdź pojazd')}
		</Button>
	)
}